module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/nature.21fc623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/nature.jpg
// module id = +lrT
// module chunks = 0